module.exports = __webpack_public_path__ + "img/SMBC 2.18f23d6c.png";